export const TOPUP_STATUS = {
  FAIL: 'fail',
  PENDING: 'pending',
  SUCCESS: 'succeed'
};

// payment_method value that, together with a processing fee above zero, makes a
// top-up a tax invoice rather than a receipt. Both the wallet transaction list
// and the document it downloads decide from this, so it must not be duplicated.
export const PAYPAL_MULTI_REDIRECT = 'paypalmulti_redirect';

/** Does this top-up get a tax invoice? Anything else gets a receipt. */
export const isTaxInvoiceTopUp = (record) =>
  record?.payment_method === PAYPAL_MULTI_REDIRECT &&
  Number(record?.processing_fee || 0) > 0;

export const TOAST_OPTIONS = {
  toastId: 'topUpError',
  autoClose: 8000
};

export const PAYMENT_STATUS = {
  FAIL: 'fail',
  PENDING: 'pending',
  SUCCESS: 'succeed'
};

export const PAY_STATUS_CODE = {
  SUCCESS: 0,
  FAIL: 1,
  VERIFYING: 2,
  EXISTS_VERIFYING: 3
};

export const PAY_STATUS_TEXT = {
  0: 'success',
  1: 'failed',
  2: 'verifying',
  3: 'exists-verifying'
};

export const CREDIT_SOURCE_MAP = {
  BANK_TRANSFER: {
    value: 1,
    text: 'Bank Transfer'
  }, // EPP - Bank Transfer [BANK_TRANSFER, BANK_TRANSFER_LEGACY]
  REFUND_CREDIT: {
    value: 4,
    text: 'Wallet Refund'
  }, // RC - Credit Refund
  PAYPAL: {
    value: 0,
    text: 'PayPal'
  }, // PPP - Paypal, [PAYPAL, PAYPAL_LEGACY]
  REFUND_REBATE: {
    value: 5,
    text: 'Rebate Refund'
  }, // RR - Rebate Refund
  REBATE_VOUCHER: {
    value: 3,
    text: 'Rebate Voucher',
    // disable: true
  }, // RV - Rebate Voucher
  VIRTUAL_CREDIT: {
    value: 2,
    text: 'Virtual Credit'
  } // VC - Virtual Credit
};

export const CREDIT_SOURCES_OPTIONS = Object.values(CREDIT_SOURCE_MAP).filter(
  (item) => !item.disable
);

/* 

    FAIL: 'fail',
    PENDING: 'pending',
    SUCCESS: 'succeed'
  
*/
export const PAYMENT_STATUS_OPTIONS = [
  {
    value: 'succeed',
    text: 'Completed'
  },
  {
    value: 'pending',
    text: 'Verifying Payment'
  }
];

export const RECHARGE_HEADERS = [
  { label: 'Source', key: 'source' },
  { label: 'Transaction ID', key: 'transaction_id' },
  { label: 'Date', key: 'effect_time' },
  { label: 'Amount', key: 'amount' },
  { label: 'Status', key: 'status' },
  { label: 'Remark', key: 'remark' }
];

export const USED_HEADERS = [
  { label: 'Order ID', key: 'order_id' },
  { label: 'Date', key: 'created_at' },
  { label: 'Amount', key: 'amount' }
];

export const STATUS_CLASS_TYPE = {
  succeed: 'success',
  pending: 'warning',
  fail: 'danger'
};
